import { useState, type ReactNode, type FC } from 'react';
import PeopleListingContext, { type PeopleListingContextProps, type PeopleListingProps } from './PeopleListingContext';
import { type ActiveFilter } from '3-components/ListingApp/ListingFilters/ListingFiltersTypes';
import { getActiveFiltersFromURL, getPageFromURL } from '3-components/ListingApp/ListingFilters/ListingFilterHelpers';

interface PeopleListingProviderProps extends PeopleListingProps {
    children: ReactNode;
}

const PeopleListingProvider: FC<PeopleListingProviderProps> = ({
    listing,
    children,
    serverPageUrl,
    ...restProps
}) => {
    const activeFiltersInitialValue = getActiveFiltersFromURL(listing.filters, new URL(serverPageUrl).search);
    const [activeFilters, setActiveFilters] = useState<ActiveFilter[]>(activeFiltersInitialValue);

    const [page, setPage] = useState(getPageFromURL(new URL(serverPageUrl).search));

    const providerValue: PeopleListingContextProps = {
        activeFilters,
        setActiveFilters,
        page,
        setPage,
        listing,
        serverPageUrl,
        ...restProps,
    };

    return (
        <PeopleListingContext.Provider value={providerValue}>
            {children}
        </PeopleListingContext.Provider>
    );
};

export default PeopleListingProvider;
